import { NavLink, useLocation } from "react-router-dom";
import clsx from "clsx";
import { BOTTOM_NAV, BOTTOM_NAV_PRIMARY, isNavItemActive } from "@/lib/nav";
import { NavBadge } from "@/navigation/NavBadge";
import { NavIcon } from "@/navigation/NavIcon";
import { MoreMenuSheet } from "@/navigation/MoreMenuSheet";
import { useNav } from "@/navigation/navContext";
import { useNavAccess } from "@/navigation/useNavAccess";

export function BottomNav() {
  const { pathname } = useLocation();
  const { setMoreMenuOpen, badges } = useNav();
  const allowed = useNavAccess(BOTTOM_NAV_PRIMARY);
  const moreVisible = BOTTOM_NAV.some((i) => i.key === "more");

  const moreHasBadge =
    badges.inquiriesOpen > 0 ||
    badges.arrivalsToday > 0 ||
    badges.departuresToday > 0 ||
    badges.ticketsOpen > 0;
  const moreActive =
    pathname.startsWith("/platzplan") ||
    pathname.startsWith("/planner") ||
    pathname.startsWith("/guests") ||
    pathname.startsWith("/invoices") ||
    pathname.startsWith("/pos") ||
    pathname.startsWith("/cashbook") ||
    pathname.startsWith("/daily-closing") ||
    pathname.startsWith("/stammdaten") ||
    pathname.startsWith("/reports") ||
    pathname.startsWith("/audit") ||
    pathname.startsWith("/contracts") ||
    pathname.startsWith("/tickets");

  return (
    <>
      <nav
        data-tour="bottom-nav"
        className="eh-bottom-nav fixed bottom-0 left-0 right-0 z-40 border-t border-separator bg-app lg:hidden"
        aria-label="Hauptnavigation"
      >
        <ul
          className="grid"
          style={{ gridTemplateColumns: `repeat(${allowed.length + (moreVisible ? 1 : 0)}, minmax(0, 1fr))` }}
        >
          {allowed.map((item) => {
            const active = isNavItemActive(pathname, item.href);
            return (
              <li key={item.key}>
                <NavLink
                  to={item.href}
                  end={item.href === "/"}
                  className={clsx(
                    "relative flex min-h-[var(--eh-bottom-nav-height)] flex-col items-center justify-center gap-0.5 px-1 pb-0.5 pt-1.5 text-[0.6875rem] font-medium transition-colors touch-manipulation",
                    active ? "text-accent" : "text-label-secondary",
                  )}
                >
                  {item.icon ? (
                    <NavIcon
                      name={item.icon}
                      size={22}
                      className={active ? "text-accent" : undefined}
                    />
                  ) : null}
                  <span className="max-w-full truncate">{item.label}</span>
                  <span className="pointer-events-none absolute right-1.5 top-0.5">
                    <NavBadge item={item} badges={badges} active={active} />
                  </span>
                </NavLink>
              </li>
            );
          })}
          {moreVisible ? (
            <li>
              <button
                type="button"
                onClick={() => setMoreMenuOpen(true)}
                className={clsx(
                  "relative flex w-full min-h-[var(--eh-bottom-nav-height)] flex-col items-center justify-center gap-0.5 px-1 pb-0.5 pt-1 text-[0.625rem] font-medium transition-colors",
                  moreActive ? "text-accent" : "text-label-secondary",
                )}
                aria-label="Weitere Bereiche"
                aria-haspopup="dialog"
              >
                <NavIcon name="Menu" size={22} className={moreActive ? "text-accent" : undefined} />
                <span>Mehr</span>
                {moreHasBadge ? (
                  <span
                    className="absolute right-3 top-1.5 h-2 w-2 rounded-full bg-status-red"
                    aria-hidden
                  />
                ) : null}
              </button>
            </li>
          ) : null}
        </ul>
      </nav>
      <MoreMenuSheet />
    </>
  );
}
